import { useCallback, useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import heroSlide1 from "@/assets/hero-slide-1.png.asset.json";
import heroSlide2 from "@/assets/hero-slide-2.png.asset.json";

type Slide = { image: string; alt: string };

// Add or edit slides here — the carousel adapts automatically.
const slides: Slide[] = [
  { image: heroSlide1.url, alt: "0% interest finance up to $15,000 and buy before winter save up to 37% — ACG Southern Highlands" },
  { image: heroSlide2.url, alt: "Winter sale — Rinnai ducted system from $17.50 per week with government rebates included" },
];

const HeroBanner = () => {
  const [index, setIndex] = useState(0);
  const total = slides.length;

  const next = useCallback(() => setIndex((i) => (i + 1) % total), [total]);
  const prev = useCallback(() => setIndex((i) => (i - 1 + total) % total), [total]);

  useEffect(() => {
    if (total < 2) return;
    const id = window.setInterval(next, 7000);
    return () => window.clearInterval(id);
  }, [next, total]);

  return (
    <section className="relative overflow-hidden">
      <div className="relative">
        <div className="flex transition-transform duration-700 ease-out" style={{ transform: `translateX(-${index * 100}%)` }}>
          {slides.map((slide, i) => (
            <img
              key={slide.image}
              src={slide.image}
              alt={slide.alt}
              className="w-full flex-shrink-0 object-cover h-[280px] sm:h-[400px] lg:h-[560px]"
              width={1920}
              height={560}
              loading={i === 0 ? "eager" : "lazy"}
              fetchPriority={i === 0 ? "high" : "auto"}
            />
          ))}
        </div>

        {total > 1 && (
          <>
            <button
              type="button"
              onClick={prev}
              aria-label="Previous slide"
              className="absolute left-3 top-1/2 -translate-y-1/2 z-20 rounded-full bg-acg-dark/70 hover:bg-acg-dark p-2 text-primary-foreground"
            >
              <ChevronLeft className="w-6 h-6" />
            </button>
            <button
              type="button"
              onClick={next}
              aria-label="Next slide"
              className="absolute right-3 top-1/2 -translate-y-1/2 z-20 rounded-full bg-acg-dark/70 hover:bg-acg-dark p-2 text-primary-foreground"
            >
              <ChevronRight className="w-6 h-6" />
            </button>
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-20 flex gap-2">
              {slides.map((s, i) => (
                <button
                  key={s.image}
                  type="button"
                  onClick={() => setIndex(i)}
                  aria-label={`Go to slide ${i + 1}`}
                  aria-current={i === index}
                  className={`h-2.5 rounded-full transition-all ${
                    i === index ? "w-8 bg-primary" : "w-2.5 bg-primary-foreground/50"
                  }`}
                />
              ))}
            </div>
          </>
        )}
      </div>

      {/* Zip Money Bar */}
      <div className="bg-acg-dark flex items-center justify-center gap-4 py-2 px-4">
        <p className="text-primary-foreground text-sm">
          Up to <span className="font-bold">60 months</span> interest free with Zip Money*
        </p>
        <a href="#" className="bg-primary text-primary-foreground text-xs font-bold px-3 py-1 rounded">
          Learn more
        </a>
      </div>
    </section>
  );
};

export default HeroBanner;
